const bazarDetailNp = {
  loading: 'बजार विवरण लोड हुँदैछ...',
  hero: {
    shops: 'दोकान',
    dailyVisitors: 'दैनिक आगन्तुक',
    size: 'करिब आकार',
    rating: 'रेटिङ'
  },
  specialties: {
    title: 'विशेषता',
    buyHere: 'यहाँबाट खरीद गर्नुहोस्'
  },
  tabs: {
    overview: 'ओभरभ्यू',
    stores: 'दोकानहरू',
    reviews: 'समीक्षा'
  },
  overview: {
    aboutSuffix: ' बारेमा',
    details: 'विस्तृत विवरण',
    contact: 'सम्पर्क',
    address: 'ठेगाना',
    phone: 'फोन',
    email: 'इमेल',
    openingHours: 'खुल्ने समय',
    location: 'स्थान',
    rating: 'रेटिङ',
    mapLoading: 'नक्शा लोड हुँदैछ...'
  },
  sidebarInfo: {
    title: 'द्रुत जानकारी',
    established: 'स्थापना',
    weeklyHoliday: 'साप्ताहिक बिदा',
    size: 'आकार',
    rating: 'रेटिङ'
  },
  facilities: {
    title: 'सुविधाहरू',
    parkingYes: 'पार्किङ उपलब्ध',
    parkingNo: 'पार्किङ छैन',
    atmYes: 'एटीएम उपलब्ध',
    atmNo: 'एटीएम छैन',
    wheelchairYes: 'व्हिलचेयर पहुँचयोग्य',
    wheelchairNo: 'व्हिलचेयर पहुँचयोग्य छैन'
  },
  stores: {
    title: (name) => `${name} काे दोकानहरू`,
    categoryPrefix: 'कोटी: ',
    viewStore: 'दोकान हेर्नुहोस्'
  },
  reviews: {
    title: 'ग्राहक समीक्षा',
    loadMore: 'अरु हेर्नुहोस्',
    summaryTitle: 'रेटिङ सारांश',
    basedOn: (n) => `${n} समीक्षाको आधारमा`
  },
  writeReview: {
    title: 'समीक्षा लेख्नुहोस्',
    subtitle: 'तपाईंको अनुभव साझेदारी गर्नुहोस्',
    button: 'समीक्षा लेख्नुहोस्'
  }
};

export default bazarDetailNp;


